const purchaseItemType = {
  SERVICE_SUBSCRIPTION: "SERVICE_SUBSCRIPTION"
};

export default purchaseItemType;